module.exports = "\n\n\n\n\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/panels/c-suite/c-suite.component.css
// module id = ./src/app/profile/panels/c-suite/c-suite.component.css
// module chunks = main